import type { CountryInfo } from "@/types/common"
import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	list() {
		return HttpClient.get<CountryInfo[]>(`${STATIC_ROOT}/countries`)
	}
}
